// libs
import React, { memo, MouseEvent } from 'react';
import { Theme } from '@nykaa/ui-components/themes/types';

//styles
import { Container, IconWrapper } from './styles';

// hooks
import useTheme from '@nykaa/ui-components/themes/hooks/useTheme';

// icons
import { useStoreIcon, IconName } from 'shared/icons';

const TEXT = 'Item added to your Cart';

const EMPTY_FUNC = () => { };

interface CartNudge {
  onClick?: VoidFunction;
}

function CartNudge({ onClick = EMPTY_FUNC }: CartNudge) {
  const theme: Theme = useTheme();
  const ShoppingBagIcon = useStoreIcon(IconName.CART);

  const onClickHandler = (event: MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    onClick();
  };

  return (
    <Container onClick={onClickHandler}>
      <IconWrapper>
        <ShoppingBagIcon color={theme.colors.surface} />
      </IconWrapper>
      {TEXT}
    </Container>
  );
}

export default memo(CartNudge);
